export default "__VITE_ASSET__bvVVash___"